/**
 * Map Signal Bridge weather conditionIcon values → MUI icons.
 * Do not use WeatherAPI CDN URLs.
 */
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import WbCloudyIcon from '@mui/icons-material/WbCloudy';
import CloudIcon from '@mui/icons-material/Cloud';
import GrainIcon from '@mui/icons-material/Grain';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FoggyIcon from '@mui/icons-material/Foggy';
import AirIcon from '@mui/icons-material/Air';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const WEATHER_ICON_KEYS = Object.freeze([
  'sunny',
  'clear-night',
  'partly-cloudy',
  'cloudy',
  'rain',
  'storm',
  'snow',
  'fog',
  'wind',
  'unknown',
]);

const WEATHER_ICON_MAP = Object.freeze({
  sunny: WbSunnyIcon,
  'clear-night': NightsStayIcon,
  'partly-cloudy': WbCloudyIcon,
  cloudy: CloudIcon,
  rain: GrainIcon,
  storm: ThunderstormIcon,
  snow: AcUnitIcon,
  fog: FoggyIcon,
  wind: AirIcon,
  unknown: HelpOutlineIcon,
});

/**
 * @param {string} [conditionIcon]
 * @returns {import('@mui/material').SvgIconComponent}
 */
export function getWeatherIconComponent(conditionIcon) {
  const key = String(conditionIcon || '').trim().toLowerCase();
  return WEATHER_ICON_MAP[key] || WEATHER_ICON_MAP.unknown;
}

/**
 * @param {string} [conditionIcon]
 * @returns {string} Normalized SB icon key (falls back to "unknown")
 */
export function resolveWeatherIconKey(conditionIcon) {
  const key = String(conditionIcon || '').trim().toLowerCase();
  return WEATHER_ICON_MAP[key] ? key : 'unknown';
}
